document.addEventListener("DOMContentLoaded", function() {
    // Select the third menu item using the provided selector
    var menuItem = document.querySelector("#shopify-section-sections--17166831911104__729ed7ff-cd70-41ab-97b7-db284c5764d5 > div > div.m-header__nav.m-section--padding.m-color-background-1.m-gradient.m\\:hidden.xl\\:m\\:block > div > div > div.m-header__menu-center > nav > ul > li:nth-child(5)");
    
    // Select the custom callout
    var callout = document.querySelector(".custom-calloutz"); // Use class to select

    if (menuItem) {
        // Function to show the callout
        function showCallout() {
            callout.style.display = "block"; // Set to block to allow positioning
            setTimeout(() => {
                callout.classList.add('show'); // Add the 'show' class after display is set
            }, 10); // Delay to allow CSS transition to take effect
            var rect = menuItem.getBoundingClientRect();
            callout.style.left = rect.left + "px"; // Adjust the callout's horizontal position
            callout.style.top = (rect.bottom + window.scrollY) + "px"; // Position the callout below the menu item
        }

        // Function to hide the callout
        function hideCallout() {
            callout.classList.remove('show'); // Remove the 'show' class
            // Delay to allow transition to finish before setting display to none
            setTimeout(() => {
                callout.style.display = "none"; // Hide it after transition
            }, 300); // Match with the CSS transition duration
        }

        // When hovering over the third menu item, show the callout
        menuItem.addEventListener("mouseenter", showCallout);
        // When the mouse leaves the menu item, check if it's on the callout
        menuItem.addEventListener("mouseleave", function() {
            if (!callout.matches(':hover')) {
                hideCallout();
            }
        });

        // Show the callout when hovering over it
        callout.addEventListener("mouseenter", showCallout);
        // Hide the callout when the mouse leaves the callout
        callout.addEventListener("mouseleave", hideCallout);
    }
});
